/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AssumptionList } from '../model';
// @ts-ignore
import { CreateEntity } from '../model';
// @ts-ignore
import { CreateEntityResponse } from '../model';
// @ts-ignore
import { DeleteCheckResponse } from '../model';
// @ts-ignore
import { Entity } from '../model';
// @ts-ignore
import { EntityAncestorPathItem } from '../model';
// @ts-ignore
import { EntityCreationResponse } from '../model';
// @ts-ignore
import { EntityDetail } from '../model';
// @ts-ignore
import { EntityExplorationRequest } from '../model';
// @ts-ignore
import { EntityExplorationResponse } from '../model';
// @ts-ignore
import { EntityLink } from '../model';
// @ts-ignore
import { EntityWithOutDegree } from '../model';
// @ts-ignore
import { LockCheckResponse } from '../model';
// @ts-ignore
import { PageEntityBasic } from '../model';
// @ts-ignore
import { Perspective } from '../model';
/**
 * EntityApi - axios parameter creator
 * @export
 */
export const EntityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Previews deleting the selected Entities with their enabled descendants. The delete goes ahead only when no selected Entity is refused: `Entity.DELETE` must reach the Entity Type of every Entity in each subtree, no subtree may hold a record of a bulk-upload Entity Type, and no selected Entity may be locked or have relationships. The selection must name exactly one Entity Type, or the request is refused with 400. 
         * @summary Predelete check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDeleteEntities: async (perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities/delete/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Previews locking the selected Entities, with and without their descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.LOCK_BULK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the selected Entities, not to their descendants. 
         * @summary Prelock check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLockEntities: async (perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities/lock/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Previews locking the Entity, with and without its descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.LOCK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the Entity itself, not to its descendants. 
         * @summary Checks locking one entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLockEntity: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkLockEntity', 'id', id)
            const localVarPath = `/navigator/entities/{id}/lock/check`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Previews unlocking the selected Entities, with and without their descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.UNLOCK_BULK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the selected Entities, not to their descendants. 
         * @summary Preunlock check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUnlockEntities: async (perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities/unlock/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Previews unlocking the Entity, with and without its descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.UNLOCK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the Entity itself, not to its descendants. 
         * @summary Checks unlocking one entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUnlockEntity: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkUnlockEntity', 'id', id)
            const localVarPath = `/navigator/entities/{id}/unlock/check`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Copies to a new sub-entity of a given entity
         * @param {number} entityId 
         * @param {number} entityTypeId 
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyToSubEntity: async (entityId: number, entityTypeId: number, shortName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('copyToSubEntity', 'entityId', entityId)
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('copyToSubEntity', 'entityTypeId', entityTypeId)
            // verify required parameter 'shortName' is not null or undefined
            assertParamExists('copyToSubEntity', 'shortName', shortName)
            const localVarPath = `/navigator/entities/{entityId}/copy?entityTypeId={entityTypeId}&shortName={shortName}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"entityTypeId"}}`, encodeURIComponent(String(entityTypeId)))
                .replace(`{${"shortName"}}`, encodeURIComponent(String(shortName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary creates an entity
         * @param {CreateEntity} [entity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntity: async (entity?: CreateEntity, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entity, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes every selected Entity with its enabled descendants, or none of them. A refused selection, as `checkDeleteEntities` reports, refuses the whole delete with 409. The selection must name exactly one Entity Type, or the request is refused with 400. 
         * @summary Deletes the selected entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntities: async (perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deletes an entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntity: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEntity', 'id', id)
            const localVarPath = `/navigator/entities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Copies to a new sub-entity of a given entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyTest: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary duplicates the entity of a given entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateEntity: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('duplicateEntity', 'entityId', entityId)
            const localVarPath = `/navigator/entities/{entityId}/duplicate`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the enable entity ids
         * @param {Array<number>} [entityIds] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enabledEntityIds: async (entityIds?: Array<number>, parentEntityId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/navent/entityIds/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the bulk entity relationships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBulkEntities: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entrel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list target  entities for a given node
         * @param {number} id 
         * @param {string} [name] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTargetEntities: async (id: number, name?: string, parentEntityId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidateTargetEntities', 'id', id)
            const localVarPath = `/navigator/entities/{id}/targetCandidates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the entities for the navigator
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntities: async (name?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the entities for the navigator
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitiesWithOutDegree: async (name?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities/projection/outDegree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the entity detail for the navigator
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntity: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEntity', 'id', id)
            const localVarPath = `/navigator/entities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets an ancestors for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAncestors: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityAncestors', 'entityId', entityId)
            const localVarPath = `/navigator/entities/{entityId}/ancestors`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a page of entity basics for navigator
         * @param {number} [filter] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [entityType] 
         * @param {string} [searchType] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityBasicsPaged: async (filter?: number, page?: number, size?: number, sort?: string, search?: string, entityType?: Array<number>, searchType?: string, parentEntityId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/navent/entityBasics/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (entityType) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets an exploration for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityExploration: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityExploration', 'entityId', entityId)
            const localVarPath = `/navigator/entities/{entityId}/exploration`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the links for the entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLinks: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityLinks', 'entityId', entityId)
            const localVarPath = `/entity/link/entities/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the total target/child entities for a given node
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTargetCount: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEntityTargetCount', 'id', id)
            const localVarPath = `/navigator/entities/{id}/targets/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the target/child entities for a given node optionally filtered by name
         * @param {number} id 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTargets: async (id: number, name?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEntityTargets', 'id', id)
            const localVarPath = `/navigator/entities/{id}/targets`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Determines if entity is frozen or not.
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isNonFrozen: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('isNonFrozen', 'entityId', entityId)
            const localVarPath = `/navigator/entities/{entityId}/nonFrozen`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Locks the entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {boolean} [includeDescendants] Also lock the selected Entities\&#39; descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.LOCK_BULK&#x60; grant are locked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still locked. Group rules apply to the selected Entities, not to their descendants. 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEntities: async (perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, includeDescendants?: boolean, perspective2?: Perspective, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }

            if (includeDescendants !== undefined) {
                localVarQueryParameter['includeDescendants'] = includeDescendants;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Locks one entity
         * @param {number} id 
         * @param {boolean} [includeDescendants] Also lock the Entity\&#39;s descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.LOCK&#x60; grant are locked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still locked. Group rules apply to the Entity itself, not to its descendants. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEntity: async (id: number, includeDescendants?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lockEntity', 'id', id)
            const localVarPath = `/navigator/entities/{id}/lock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeDescendants !== undefined) {
                localVarQueryParameter['includeDescendants'] = includeDescendants;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlocks the entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {boolean} [includeDescendants] Also unlock the selected Entities\&#39; descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.UNLOCK_BULK&#x60; grant are unlocked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still unlocked. Group rules apply to the selected Entities, not to their descendants. 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockEntities: async (perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, includeDescendants?: boolean, perspective2?: Perspective, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entities/unlock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }

            if (includeDescendants !== undefined) {
                localVarQueryParameter['includeDescendants'] = includeDescendants;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlocks one entity
         * @param {number} id 
         * @param {boolean} [includeDescendants] Also unlock the Entity\&#39;s descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.UNLOCK&#x60; grant are unlocked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still unlocked. Group rules apply to the Entity itself, not to its descendants. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockEntity: async (id: number, includeDescendants?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unlockEntity', 'id', id)
            const localVarPath = `/navigator/entities/{id}/unlock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeDescendants !== undefined) {
                localVarQueryParameter['includeDescendants'] = includeDescendants;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an exploration for an entity
         * @param {number} entityId 
         * @param {EntityExplorationRequest} [entityExplorationRequest] entitiy exporation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityExploration: async (entityId: number, entityExplorationRequest?: EntityExplorationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('updateEntityExploration', 'entityId', entityId)
            const localVarPath = `/navigator/entities/{entityId}/exploration`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityExplorationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityApi - functional programming interface
 * @export
 */
export const EntityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityApiAxiosParamCreator(configuration)
    return {
        /**
         * Previews deleting the selected Entities with their enabled descendants. The delete goes ahead only when no selected Entity is refused: `Entity.DELETE` must reach the Entity Type of every Entity in each subtree, no subtree may hold a record of a bulk-upload Entity Type, and no selected Entity may be locked or have relationships. The selection must name exactly one Entity Type, or the request is refused with 400. 
         * @summary Predelete check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkDeleteEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkDeleteEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Previews locking the selected Entities, with and without their descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.LOCK_BULK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the selected Entities, not to their descendants. 
         * @summary Prelock check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkLockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkLockEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Previews locking the Entity, with and without its descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.LOCK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the Entity itself, not to its descendants. 
         * @summary Checks locking one entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkLockEntity(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkLockEntity(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Previews unlocking the selected Entities, with and without their descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.UNLOCK_BULK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the selected Entities, not to their descendants. 
         * @summary Preunlock check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUnlockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUnlockEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Previews unlocking the Entity, with and without its descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.UNLOCK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the Entity itself, not to its descendants. 
         * @summary Checks unlocking one entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUnlockEntity(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUnlockEntity(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Copies to a new sub-entity of a given entity
         * @param {number} entityId 
         * @param {number} entityTypeId 
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyToSubEntity(entityId: number, entityTypeId: number, shortName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyToSubEntity(entityId, entityTypeId, shortName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary creates an entity
         * @param {CreateEntity} [entity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntity(entity?: CreateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntity(entity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes every selected Entity with its enabled descendants, or none of them. A refused selection, as `checkDeleteEntities` reports, refuses the whole delete with 409. The selection must name exactly one Entity Type, or the request is refused with 400. 
         * @summary Deletes the selected entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deletes an entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntity(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntity(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Copies to a new sub-entity of a given entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dummyTest(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssumptionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dummyTest(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary duplicates the entity of a given entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateEntity(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateEntity(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the enable entity ids
         * @param {Array<number>} [entityIds] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enabledEntityIds(entityIds?: Array<number>, parentEntityId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enabledEntityIds(entityIds, parentEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the bulk entity relationships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBulkEntities(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Entity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBulkEntities(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list target  entities for a given node
         * @param {number} id 
         * @param {string} [name] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateTargetEntities(id: number, name?: string, parentEntityId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateTargetEntities(id, name, parentEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the entities for the navigator
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntities(name?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Entity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntities(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the entities for the navigator
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntitiesWithOutDegree(name?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityWithOutDegree>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntitiesWithOutDegree(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the entity detail for the navigator
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntity(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntity(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets an ancestors for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAncestors(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityAncestorPathItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAncestors(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a page of entity basics for navigator
         * @param {number} [filter] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [entityType] 
         * @param {string} [searchType] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityBasicsPaged(filter?: number, page?: number, size?: number, sort?: string, search?: string, entityType?: Array<number>, searchType?: string, parentEntityId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntityBasic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityBasicsPaged(filter, page, size, sort, search, entityType, searchType, parentEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets an exploration for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityExploration(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityExplorationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityExploration(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the links for the entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLinks(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityLinks(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the total target/child entities for a given node
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityTargetCount(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityTargetCount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the target/child entities for a given node optionally filtered by name
         * @param {number} id 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityTargets(id: number, name?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityWithOutDegree>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityTargets(id, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Determines if entity is frozen or not.
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isNonFrozen(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isNonFrozen(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Locks the entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {boolean} [includeDescendants] Also lock the selected Entities\&#39; descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.LOCK_BULK&#x60; grant are locked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still locked. Group rules apply to the selected Entities, not to their descendants. 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, includeDescendants?: boolean, perspective2?: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockEntities(perspective, filter, entityIds, page, search, parentEntityId, includeDescendants, perspective2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Locks one entity
         * @param {number} id 
         * @param {boolean} [includeDescendants] Also lock the Entity\&#39;s descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.LOCK&#x60; grant are locked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still locked. Group rules apply to the Entity itself, not to its descendants. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockEntity(id: number, includeDescendants?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockEntity(id, includeDescendants, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlocks the entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {boolean} [includeDescendants] Also unlock the selected Entities\&#39; descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.UNLOCK_BULK&#x60; grant are unlocked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still unlocked. Group rules apply to the selected Entities, not to their descendants. 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, includeDescendants?: boolean, perspective2?: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockEntities(perspective, filter, entityIds, page, search, parentEntityId, includeDescendants, perspective2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlocks one entity
         * @param {number} id 
         * @param {boolean} [includeDescendants] Also unlock the Entity\&#39;s descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.UNLOCK&#x60; grant are unlocked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still unlocked. Group rules apply to the Entity itself, not to its descendants. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockEntity(id: number, includeDescendants?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockEntity(id, includeDescendants, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an exploration for an entity
         * @param {number} entityId 
         * @param {EntityExplorationRequest} [entityExplorationRequest] entitiy exporation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityExploration(entityId: number, entityExplorationRequest?: EntityExplorationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityExplorationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityExploration(entityId, entityExplorationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntityApi - factory interface
 * @export
 */
export const EntityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityApiFp(configuration)
    return {
        /**
         * Previews deleting the selected Entities with their enabled descendants. The delete goes ahead only when no selected Entity is refused: `Entity.DELETE` must reach the Entity Type of every Entity in each subtree, no subtree may hold a record of a bulk-upload Entity Type, and no selected Entity may be locked or have relationships. The selection must name exactly one Entity Type, or the request is refused with 400. 
         * @summary Predelete check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDeleteEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any): AxiosPromise<DeleteCheckResponse> {
            return localVarFp.checkDeleteEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options).then((request) => request(axios, basePath));
        },
        /**
         * Previews locking the selected Entities, with and without their descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.LOCK_BULK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the selected Entities, not to their descendants. 
         * @summary Prelock check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any): AxiosPromise<LockCheckResponse> {
            return localVarFp.checkLockEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options).then((request) => request(axios, basePath));
        },
        /**
         * Previews locking the Entity, with and without its descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.LOCK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the Entity itself, not to its descendants. 
         * @summary Checks locking one entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLockEntity(id: number, options?: any): AxiosPromise<LockCheckResponse> {
            return localVarFp.checkLockEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Previews unlocking the selected Entities, with and without their descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.UNLOCK_BULK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the selected Entities, not to their descendants. 
         * @summary Preunlock check
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUnlockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any): AxiosPromise<LockCheckResponse> {
            return localVarFp.checkUnlockEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options).then((request) => request(axios, basePath));
        },
        /**
         * Previews unlocking the Entity, with and without its descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.UNLOCK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the Entity itself, not to its descendants. 
         * @summary Checks unlocking one entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUnlockEntity(id: number, options?: any): AxiosPromise<LockCheckResponse> {
            return localVarFp.checkUnlockEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Copies to a new sub-entity of a given entity
         * @param {number} entityId 
         * @param {number} entityTypeId 
         * @param {string} shortName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyToSubEntity(entityId: number, entityTypeId: number, shortName: string, options?: any): AxiosPromise<EntityCreationResponse> {
            return localVarFp.copyToSubEntity(entityId, entityTypeId, shortName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary creates an entity
         * @param {CreateEntity} [entity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntity(entity?: CreateEntity, options?: any): AxiosPromise<CreateEntityResponse> {
            return localVarFp.createEntity(entity, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes every selected Entity with its enabled descendants, or none of them. A refused selection, as `checkDeleteEntities` reports, refuses the whole delete with 409. The selection must name exactly one Entity Type, or the request is refused with 400. 
         * @summary Deletes the selected entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any): AxiosPromise<number> {
            return localVarFp.deleteEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deletes an entity
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntity(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Copies to a new sub-entity of a given entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyTest(options?: any): AxiosPromise<AssumptionList> {
            return localVarFp.dummyTest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary duplicates the entity of a given entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateEntity(entityId: number, options?: any): AxiosPromise<EntityCreationResponse> {
            return localVarFp.duplicateEntity(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the enable entity ids
         * @param {Array<number>} [entityIds] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enabledEntityIds(entityIds?: Array<number>, parentEntityId?: number, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.enabledEntityIds(entityIds, parentEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the bulk entity relationships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBulkEntities(options?: any): AxiosPromise<Array<Entity>> {
            return localVarFp.getBulkEntities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list target  entities for a given node
         * @param {number} id 
         * @param {string} [name] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTargetEntities(id: number, name?: string, parentEntityId?: number, options?: any): AxiosPromise<Array<EntityDetail>> {
            return localVarFp.getCandidateTargetEntities(id, name, parentEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the entities for the navigator
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntities(name?: string, options?: any): AxiosPromise<Array<Entity>> {
            return localVarFp.getEntities(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the entities for the navigator
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitiesWithOutDegree(name?: string, options?: any): AxiosPromise<Array<EntityWithOutDegree>> {
            return localVarFp.getEntitiesWithOutDegree(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the entity detail for the navigator
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntity(id: number, options?: any): AxiosPromise<EntityDetail> {
            return localVarFp.getEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets an ancestors for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAncestors(entityId: number, options?: any): AxiosPromise<Array<EntityAncestorPathItem>> {
            return localVarFp.getEntityAncestors(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a page of entity basics for navigator
         * @param {number} [filter] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [entityType] 
         * @param {string} [searchType] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityBasicsPaged(filter?: number, page?: number, size?: number, sort?: string, search?: string, entityType?: Array<number>, searchType?: string, parentEntityId?: number, options?: any): AxiosPromise<PageEntityBasic> {
            return localVarFp.getEntityBasicsPaged(filter, page, size, sort, search, entityType, searchType, parentEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets an exploration for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityExploration(entityId: number, options?: any): AxiosPromise<EntityExplorationResponse> {
            return localVarFp.getEntityExploration(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the links for the entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLinks(entityId: number, options?: any): AxiosPromise<Array<EntityLink>> {
            return localVarFp.getEntityLinks(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the total target/child entities for a given node
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTargetCount(id: number, options?: any): AxiosPromise<number> {
            return localVarFp.getEntityTargetCount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the target/child entities for a given node optionally filtered by name
         * @param {number} id 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTargets(id: number, name?: string, options?: any): AxiosPromise<Array<EntityWithOutDegree>> {
            return localVarFp.getEntityTargets(id, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determines if entity is frozen or not.
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isNonFrozen(entityId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.isNonFrozen(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Locks the entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {boolean} [includeDescendants] Also lock the selected Entities\&#39; descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.LOCK_BULK&#x60; grant are locked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still locked. Group rules apply to the selected Entities, not to their descendants. 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, includeDescendants?: boolean, perspective2?: Perspective, options?: any): AxiosPromise<number> {
            return localVarFp.lockEntities(perspective, filter, entityIds, page, search, parentEntityId, includeDescendants, perspective2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Locks one entity
         * @param {number} id 
         * @param {boolean} [includeDescendants] Also lock the Entity\&#39;s descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.LOCK&#x60; grant are locked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still locked. Group rules apply to the Entity itself, not to its descendants. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEntity(id: number, includeDescendants?: boolean, options?: any): AxiosPromise<number> {
            return localVarFp.lockEntity(id, includeDescendants, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlocks the entities
         * @param {number} [perspective] ID of perspective for which to fetch the entity values
         * @param {number} [filter] 
         * @param {Array<number>} [entityIds] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {boolean} [includeDescendants] Also unlock the selected Entities\&#39; descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.UNLOCK_BULK&#x60; grant are unlocked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still unlocked. Group rules apply to the selected Entities, not to their descendants. 
         * @param {Perspective} [perspective2] Perspective with target entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, includeDescendants?: boolean, perspective2?: Perspective, options?: any): AxiosPromise<number> {
            return localVarFp.unlockEntities(perspective, filter, entityIds, page, search, parentEntityId, includeDescendants, perspective2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlocks one entity
         * @param {number} id 
         * @param {boolean} [includeDescendants] Also unlock the Entity\&#39;s descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.UNLOCK&#x60; grant are unlocked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still unlocked. Group rules apply to the Entity itself, not to its descendants. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockEntity(id: number, includeDescendants?: boolean, options?: any): AxiosPromise<number> {
            return localVarFp.unlockEntity(id, includeDescendants, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an exploration for an entity
         * @param {number} entityId 
         * @param {EntityExplorationRequest} [entityExplorationRequest] entitiy exporation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityExploration(entityId: number, entityExplorationRequest?: EntityExplorationRequest, options?: any): AxiosPromise<EntityExplorationResponse> {
            return localVarFp.updateEntityExploration(entityId, entityExplorationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityApi - object-oriented interface
 * @export
 * @class EntityApi
 * @extends {BaseAPI}
 */
export class EntityApi extends BaseAPI {
    /**
     * Previews deleting the selected Entities with their enabled descendants. The delete goes ahead only when no selected Entity is refused: `Entity.DELETE` must reach the Entity Type of every Entity in each subtree, no subtree may hold a record of a bulk-upload Entity Type, and no selected Entity may be locked or have relationships. The selection must name exactly one Entity Type, or the request is refused with 400. 
     * @summary Predelete check
     * @param {number} [perspective] ID of perspective for which to fetch the entity values
     * @param {number} [filter] 
     * @param {Array<number>} [entityIds] 
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {Perspective} [perspective2] Perspective with target entities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public checkDeleteEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any) {
        return EntityApiFp(this.configuration).checkDeleteEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Previews locking the selected Entities, with and without their descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.LOCK_BULK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the selected Entities, not to their descendants. 
     * @summary Prelock check
     * @param {number} [perspective] ID of perspective for which to fetch the entity values
     * @param {number} [filter] 
     * @param {Array<number>} [entityIds] 
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {Perspective} [perspective2] Perspective with target entities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public checkLockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any) {
        return EntityApiFp(this.configuration).checkLockEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Previews locking the Entity, with and without its descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.LOCK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the Entity itself, not to its descendants. 
     * @summary Checks locking one entity
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public checkLockEntity(id: number, options?: any) {
        return EntityApiFp(this.configuration).checkLockEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Previews unlocking the selected Entities, with and without their descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.UNLOCK_BULK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the selected Entities, not to their descendants. 
     * @summary Preunlock check
     * @param {number} [perspective] ID of perspective for which to fetch the entity values
     * @param {number} [filter] 
     * @param {Array<number>} [entityIds] 
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {Perspective} [perspective2] Perspective with target entities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public checkUnlockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any) {
        return EntityApiFp(this.configuration).checkUnlockEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Previews unlocking the Entity, with and without its descendants. The descendant counts include only descendants whose Entity Type is covered by the caller\'s `Entity.UNLOCK` grant. Traversal continues through an uncovered descendant, so a covered grandchild below an uncovered child is still counted. Group rules apply to the Entity itself, not to its descendants. 
     * @summary Checks unlocking one entity
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public checkUnlockEntity(id: number, options?: any) {
        return EntityApiFp(this.configuration).checkUnlockEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Copies to a new sub-entity of a given entity
     * @param {number} entityId 
     * @param {number} entityTypeId 
     * @param {string} shortName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public copyToSubEntity(entityId: number, entityTypeId: number, shortName: string, options?: any) {
        return EntityApiFp(this.configuration).copyToSubEntity(entityId, entityTypeId, shortName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary creates an entity
     * @param {CreateEntity} [entity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public createEntity(entity?: CreateEntity, options?: any) {
        return EntityApiFp(this.configuration).createEntity(entity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes every selected Entity with its enabled descendants, or none of them. A refused selection, as `checkDeleteEntities` reports, refuses the whole delete with 409. The selection must name exactly one Entity Type, or the request is refused with 400. 
     * @summary Deletes the selected entities
     * @param {number} [perspective] ID of perspective for which to fetch the entity values
     * @param {number} [filter] 
     * @param {Array<number>} [entityIds] 
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {Perspective} [perspective2] Perspective with target entities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public deleteEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, perspective2?: Perspective, options?: any) {
        return EntityApiFp(this.configuration).deleteEntities(perspective, filter, entityIds, page, search, parentEntityId, perspective2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deletes an entity
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public deleteEntity(id: number, options?: any) {
        return EntityApiFp(this.configuration).deleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Copies to a new sub-entity of a given entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public dummyTest(options?: any) {
        return EntityApiFp(this.configuration).dummyTest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary duplicates the entity of a given entity
     * @param {number} entityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public duplicateEntity(entityId: number, options?: any) {
        return EntityApiFp(this.configuration).duplicateEntity(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the enable entity ids
     * @param {Array<number>} [entityIds] 
     * @param {number} [parentEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public enabledEntityIds(entityIds?: Array<number>, parentEntityId?: number, options?: any) {
        return EntityApiFp(this.configuration).enabledEntityIds(entityIds, parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the bulk entity relationships
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getBulkEntities(options?: any) {
        return EntityApiFp(this.configuration).getBulkEntities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list target  entities for a given node
     * @param {number} id 
     * @param {string} [name] 
     * @param {number} [parentEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getCandidateTargetEntities(id: number, name?: string, parentEntityId?: number, options?: any) {
        return EntityApiFp(this.configuration).getCandidateTargetEntities(id, name, parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the entities for the navigator
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntities(name?: string, options?: any) {
        return EntityApiFp(this.configuration).getEntities(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the entities for the navigator
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntitiesWithOutDegree(name?: string, options?: any) {
        return EntityApiFp(this.configuration).getEntitiesWithOutDegree(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the entity detail for the navigator
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntity(id: number, options?: any) {
        return EntityApiFp(this.configuration).getEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets an ancestors for an entity
     * @param {number} entityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntityAncestors(entityId: number, options?: any) {
        return EntityApiFp(this.configuration).getEntityAncestors(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a page of entity basics for navigator
     * @param {number} [filter] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [search] 
     * @param {Array<number>} [entityType] 
     * @param {string} [searchType] 
     * @param {number} [parentEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntityBasicsPaged(filter?: number, page?: number, size?: number, sort?: string, search?: string, entityType?: Array<number>, searchType?: string, parentEntityId?: number, options?: any) {
        return EntityApiFp(this.configuration).getEntityBasicsPaged(filter, page, size, sort, search, entityType, searchType, parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets an exploration for an entity
     * @param {number} entityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntityExploration(entityId: number, options?: any) {
        return EntityApiFp(this.configuration).getEntityExploration(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the links for the entity
     * @param {number} entityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntityLinks(entityId: number, options?: any) {
        return EntityApiFp(this.configuration).getEntityLinks(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the total target/child entities for a given node
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntityTargetCount(id: number, options?: any) {
        return EntityApiFp(this.configuration).getEntityTargetCount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the target/child entities for a given node optionally filtered by name
     * @param {number} id 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getEntityTargets(id: number, name?: string, options?: any) {
        return EntityApiFp(this.configuration).getEntityTargets(id, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determines if entity is frozen or not.
     * @param {number} entityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public isNonFrozen(entityId: number, options?: any) {
        return EntityApiFp(this.configuration).isNonFrozen(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Locks the entities
     * @param {number} [perspective] ID of perspective for which to fetch the entity values
     * @param {number} [filter] 
     * @param {Array<number>} [entityIds] 
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {boolean} [includeDescendants] Also lock the selected Entities\&#39; descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.LOCK_BULK&#x60; grant are locked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still locked. Group rules apply to the selected Entities, not to their descendants. 
     * @param {Perspective} [perspective2] Perspective with target entities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public lockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, includeDescendants?: boolean, perspective2?: Perspective, options?: any) {
        return EntityApiFp(this.configuration).lockEntities(perspective, filter, entityIds, page, search, parentEntityId, includeDescendants, perspective2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Locks one entity
     * @param {number} id 
     * @param {boolean} [includeDescendants] Also lock the Entity\&#39;s descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.LOCK&#x60; grant are locked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still locked. Group rules apply to the Entity itself, not to its descendants. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public lockEntity(id: number, includeDescendants?: boolean, options?: any) {
        return EntityApiFp(this.configuration).lockEntity(id, includeDescendants, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlocks the entities
     * @param {number} [perspective] ID of perspective for which to fetch the entity values
     * @param {number} [filter] 
     * @param {Array<number>} [entityIds] 
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {boolean} [includeDescendants] Also unlock the selected Entities\&#39; descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.UNLOCK_BULK&#x60; grant are unlocked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still unlocked. Group rules apply to the selected Entities, not to their descendants. 
     * @param {Perspective} [perspective2] Perspective with target entities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public unlockEntities(perspective?: number, filter?: number, entityIds?: Array<number>, page?: number, search?: string, parentEntityId?: number, includeDescendants?: boolean, perspective2?: Perspective, options?: any) {
        return EntityApiFp(this.configuration).unlockEntities(perspective, filter, entityIds, page, search, parentEntityId, includeDescendants, perspective2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlocks one entity
     * @param {number} id 
     * @param {boolean} [includeDescendants] Also unlock the Entity\&#39;s descendants. Only descendants whose Entity Type is covered by the caller\&#39;s &#x60;Entity.UNLOCK&#x60; grant are unlocked; the others are skipped. Traversal continues through a skipped descendant, so a covered grandchild below an uncovered child is still unlocked. Group rules apply to the Entity itself, not to its descendants. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public unlockEntity(id: number, includeDescendants?: boolean, options?: any) {
        return EntityApiFp(this.configuration).unlockEntity(id, includeDescendants, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an exploration for an entity
     * @param {number} entityId 
     * @param {EntityExplorationRequest} [entityExplorationRequest] entitiy exporation fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public updateEntityExploration(entityId: number, entityExplorationRequest?: EntityExplorationRequest, options?: any) {
        return EntityApiFp(this.configuration).updateEntityExploration(entityId, entityExplorationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
